/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import _ from 'lodash';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col, Statistic } from 'antd';
import { Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Examination from 'modules/Olympic/components/Examination';
import Container from 'components/Containers/Container';

import colors from 'constants/colors';
import { studentUnitExercise } from 'constants/contantsFiles';
import { updateCountDown } from '../../modules/Olympic/actions';

const { Countdown } = Statistic;

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.textColor};
  width: 36px;
  height: 36px;
  border-width: ${(props) => props.borderWidth};
  border-style: ${(props) => props.borderStype};
  border-radius: 18px;
  border-color: #adb5bd;
  background-color: ${(props) => props.color};
`;

const CircleButton = ({ children, result }) => {
  if (result === undefined) {
    return (
      <Circle className='m-1' borderStype='dashed' color='white' textColor={colors.font} borderWidth='1px'>
        {children}
      </Circle>
    );
  }

  return (
    <Circle className='m-1' borderStype='solid' color={result === true ? '#2dce89' : '#f5365c'} textColor='white' borderWidth='0px'>
      {children}
    </Circle>
  );
};

const Start = ({ match }) => {
  // Hooks
  const history = useHistory();

  // Redux
  const dispatch = useDispatch();
  const countdown = useSelector((state) => state.olympicReducer.countdown);
  const submittedQuestions = useSelector((state) => state.olympicReducer.submittedQuestions);
  const examination = useSelector((state) => state.olympicReducer.examination);

  // State
  const [answeredQuestions, setAnsweredQuestions] = React.useState(null);

  // Variables
  const correctQuestions = _.reduce(
    submittedQuestions,
    (sum, item) => {
      const value = item.userData.result ? 1 : 0;
      return sum + value;
    },
    0,
  );

  const total = examination.questions.length;
  let countTo30 = 0;

  // Effects
  React.useEffect(() => {
    setAnsweredQuestions(submittedQuestions);
  }, [match.url]);

  // Render
  return (
    <Container name={` Đề thi số ${examination.code}`} parentName='Olympic English'>
      <Row gutter={16}>
        <Col xxl={20} xl={19} lg={17} md={18} sm={24} xs={24}>
          <Examination studentUnitExercise={studentUnitExercise} />
        </Col>
        <Col xxl={4} xl={5} lg={7} md={6} sm={24} xs={24}>
          <Card>
            <CardBody>
              <div className='d-flex justify-content-center' style={{ textAlign: 'center' }}>
                <Countdown
                  title='Thời gian làm bài'
                  value={Date.now() + countdown}
                  onFinish={() => {
                    const url = `/lms/${studentUnitExercise ? 'exercise' : 'olympic'}/examination/${examination.code}/result`;
                    history.push(url);
                  }}
                  onChange={(value) => {
                    countTo30++;
                    if (countTo30 === 30) {
                      countTo30 = 0;
                      dispatch(updateCountDown(value));
                    }
                  }}
                />
              </div>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <div>
                <div className='d-flex justify-content-center'>
                  <Statistic title='Kết quả' suffix={` / ${total}`} value={correctQuestions} valueStyle={{ fontSize: 16, fontWeight: 600 }} style={{ marginRight: 32, whiteSpace: 'nowrap' }} />
                  <Statistic style={{ whiteSpace: 'nowrap' }} precision={2} title='Đạt tỷ lệ' suffix='%' value={(correctQuestions / total) * 100} valueStyle={{ fontSize: 16, fontWeight: 600 }} />
                </div>
              </div>
            </CardHeader>
            <CardBody>
              <div className='d-flex flex-wrap'>
                {answeredQuestions &&
                  _.concat(
                    answeredQuestions,
                    _.map(new Array(total - answeredQuestions.length), (x) => {
                      return { item: null };
                    }),
                  ).map((item, index) => {
                    return (
                      <Col lg={6} sm={12} key={index} className='d-flex justify-content-center' style={{ padding: 0, margin: 0 }}>
                        <CircleButton result={item?.userData?.result}>{index + 1}</CircleButton>
                      </Col>
                    );
                  })}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* MODAL */}
      <Modal className='modal-dialog-centered modal-danger' contentClassName='bg-gradient-danger' isOpen={parseInt(match.params.index) <= answeredQuestions?.length}>
        <ModalHeader>
          <h6 className='modal-title' id='modal-title-notification'>
            CẢNH BÁO
          </h6>
        </ModalHeader>
        <ModalBody>
          <div className='py-3 text-center'>
            <i className='ni ni-bell-55 ni-3x' />
            <h4 className='heading mt-4'>Lưu ý quy định sau</h4>
            <p style={{ fontSize: 15 }}>Trong quá trình làm bài thi, bạn không được bấm nút quay lại (Go back) của trình duyệt. Nếu vi phạm nhiều lần, bạn sẽ bị kết thúc bài thi.</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            type='button'
            onClick={() => {
              let url = `/lms/${studentUnitExercise ? 'exercise' : 'olympic'}/examination/${examination.code}/start/${answeredQuestions.length + 1}`;
              if (answeredQuestions.length === total) {
                url = `/lms/${studentUnitExercise ? 'exercise' : 'olympic'}/examination/${examination.code}/result`;
              }
              history.push(url);
            }}
          >
            Tôi đã hiểu
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default Start;
